import stableStringify from "fast-json-stable-stringify";

/**
 * cyrb53 — fast 53-bit hash function.
 * https://stackoverflow.com/a/52171480
 */
function cyrb53(str: string, seed = 0): number {
  let h1 = 0xdeadbeef ^ seed;
  let h2 = 0x41c6ce57 ^ seed;
  for (let i = 0; i < str.length; i++) {
    const ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
  h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
  h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}

/**
 * Creates a deterministic hash string from any JSON-serializable value.
 * Uses sorted-key serialization so key order doesn't affect the result.
 */
export function createHash(obj: unknown): string {
  return cyrb53(stableStringify(obj)).toString(16);
}

export function createObjectHash<T extends object>(obj: T): string {
  return Object.keys(obj).length > 0 ? createHash(obj) : "";
}
